import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import Authentication from "./Authentication";
import BaseData from "./BaseData";

var Users =
/*#__PURE__*/
function (_BaseData) {
  _inherits(Users, _BaseData);

  function Users() {
    _classCallCheck(this, Users);

    return _possibleConstructorReturn(this, _getPrototypeOf(Users).call(this, "Users"));
  }

  _createClass(Users, [{
    key: "Register",
    value: function Register(firstName, lastName, email, phone, role, userName, isInspector, kcSl) {
      return axios.post("/api/users/Register", {
        Email: email,
        FirstName: firstName,
        LastName: lastName,
        Phone: phone,
        role: role,
        userName: userName,
        isInspector: isInspector,
        kcSl: kcSl
      });
    }
  }, {
    key: "GetUserInfo",
    value: function GetUserInfo(userId) {
      return axios.get("/api/users/GetUserInfo", {
        params: {
          userId: userId
        }
      });
    }
  }, {
    key: "GetAllUsers",
    value: function GetAllUsers() {
      var loggedInUserId = Authentication.GetUserId();
      return axios.get("/api/users/GetAll", {
        params: {
          userId: loggedInUserId
        }
      });
    }
  }, {
    key: "IsUserNameTaken",
    value: function IsUserNameTaken(userName) {
      return axios.get("/api/users/IsUserNameTaken/".concat(userName));
    }
  }, {
    key: "GetByUserName",
    value: function GetByUserName(userName) {
      return axios.get("/api/users/GetByUserName/".concat(userName));
    }
  }, {
    key: "IsUserNameTakenByUser",
    value: function IsUserNameTakenByUser(user) {
      return axios.post("/api/users/IsUserNameTakenByUser", user);
    }
  }, {
    key: "GetMcUsers",
    value: function GetMcUsers() {
      return axios.get("/api/users/GetMcUsers");
    }
  }, {
    key: "GetAllMHDCUsers",
    value: function GetAllMHDCUsers() {
      return axios.get("/api/users/GetAllMHDCUsers");
    }
  }, {
    key: "DeleteUser",
    value: function DeleteUser(userId) {
      return axios.delete("/api/users/DeleteUser", {
        params: {
          userId: userId
        }
      });
    }
  }, {
    key: "RemoveUserFromUserList",
    value: function RemoveUserFromUserList(userId) {
      return axios.delete("/api/users/RemoveUserFromUserList/".concat(userId));
    }
  }, {
    key: "EditUser",
    value: function EditUser(user) {
      return axios.patch("/api/users/EditUser", user);
    }
  }, {
    key: "CreateUserRole",
    value: function CreateUserRole(userId, roleId) {
      return axios.post("/api/users/CreateUserRole", {
        userId: userId,
        Id: roleId
      });
    }
  }, {
    key: "GetAllMcUsers",
    value: function GetAllMcUsers(managementCompanyId) {
      return axios.get("/api/users/GetAllMcUsers/".concat(managementCompanyId));
    }
  }, {
    key: "GetMCUsersByStatus",
    value: function GetMCUsersByStatus(statusId, managementCompanyId) {
      return axios.get("/api/users/GetMCUsersByStatus/".concat(statusId), {
        params: {
          managementCompanyId: managementCompanyId
        }
      });
    }
  }]);

  return Users;
}(BaseData);

export default new Users();